Vue.component('multi-file-uploader', {
    template: `
    <div class='MultiFileUploader'>
        <div v-if='isInitialized === false'>Loading...</div>

        <div class="alert alert-danger" v-if="errors.length">
            <ul class="indented">
                <li v-for="errorMessage in errorsDistinctMessages">{{ errorMessage }}</li>
            </ul>
        </div>

        <div v-if='isInitialized === true'>

            <div class="form-group text-center">
                <label id="imageUpload">
                    <input type="file" ref="inputFile" id="MultiFileUploaderInputFile" name="MultiFileUploaderInputFile" style="display:none;" :disabled="isUploadInProgress" @change="handleFileUpload">
                    <label class="btn btn-primary MultiFileUploaderInputFile_button" id="image" for="MultiFileUploaderInputFile" v-bind:class="{ 'disabled': isUploadInProgress }"><i class="fa fa-upload"></i> Select File to Upload</label>
                </label>
                <div class="progress">
                    <div id="imageProgress" class="progress-bar" v-bind:class="{ 'bg-warning': isUploadInProgress }" role="progressbar" :style="{ width: uploadPercentage + '%' }" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">File Name</th>
                        <th scope="col">Remove</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if='images.length === 0'>
                        <td colspan='3' class='text-center'>No files uploaded. Please select at least one file to continue.</td>
                    </tr>
                    <tr 
                        v-for='(image, index) in images'
                        v-bind:key='image.id'
                    >
                        <td>{{ index + 1 }}</td>
                        <td style='word-break:break-all;'>
                            <a :href='getFileUploadUrl(image.filename)' target='_blank'>
                                <span>{{ image.originalFilename }}</span>
                                <span v-if='image.originalFilePageNumber > 0'> ({{ image.originalFilePageNumber }})</span>
                            </a>
                        </td>
                        <td><button type="button" class="btn btn-danger" v-on:click='handleDelete(image.id)'>Delete</button></td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
    `,
    props: {
        urlUploadBase: String,
        urlApiGetImages: String,
        urlApiUpload: String,
        urlApiDelete: String,
    },
    data: function () {
        return {
            isInitialized: false,
            errors: [],
            images: [],
            uploadPercentage: 0,
            isUploadInProgress: false
        }
    },
    created: async function () {
        console.log('Component - multi-file-uploader - initializing..')
        console.log(this.$props.urlUploadBase);
        console.log(this.$props.urlApiGetImages);
        console.log(this.$props.urlApiUpload);
        console.log(this.$props.urlApiDelete);
        await this.initialize();
        console.log('Component - multi-file-uploader - initialization complete.')
    },
    methods: {
        initialize: async function () {
            //this.images = [{ id: 1, filename = 'test' }, { id: 2, filename = 'test 2' }];
            //await Apfco.sleep(1000);
            await this.getImages();
            this.isInitialized = true;
        },
        getImages: async function () {
            await axios.get(this.$props.urlApiGetImages).then(response => (this.images = response.data.images));
        },
        getFileUploadUrl: function (filename) {
            return this.$props.urlUploadBase + filename;
        },
        handleFileUpload: async function () {
            let thisObj = this;
            console.log('File upload starting..');

            console.log('Clearing errors and upload width..');
            this.errors = [];
            this.uploadPercentage = 0;
            this.isUploadInProgress = true;

            let file = this.$refs.inputFile.files[0];
            console.log('Uploading file..', file);
            let formData = new FormData();
            formData.append('file', file);

            await axios.post(this.$props.urlApiUpload
                , formData
                , {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    onUploadProgress: function (progressEvent) {
                        this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        console.log('Upload Percentage: '+ this.uploadPercentage);
                    }.bind(this)
                }
            )
            .then(function () {
                thisObj.isUploadInProgress = false;
                console.log('Success');
            })
            .catch(function (error) {
                thisObj.isUploadInProgress = false;
                console.log('Failed', error.response);
                //If it's a <!DOCTYPE response, it means some weird server message came back (likely the server max file size). If this happens, just display a generic message
                if (error.response.data.startsWith('<!DOCTYPE')) {
                    thisObj.errors.push({ id: "image_Upload", message: 'Your selected file was not successfully uploaded. Please ensure it is a valid file format and under the maximum file size.' });
                }
                else {
                    thisObj.errors.push({ id: "image_Upload", message: error.response.data });
                }
            });

            console.log('Refreshing file list..');
            await this.getImages();

            console.log('Clearing selected file..'); //So user can select the same file. While not likely, if not in place will be confusing (user accidentally deleting a file wouldn't be able to re-upload)
            this.$refs.inputFile.value = '';

            console.log('File upload complete.');
        },
        handleDelete: async function (id) {
            let thisObj = this;
            console.log('File upload starting..');

            console.log('Clearing errors..');
            this.errors = [];

            console.log('Deleting file..');
            await axios.post(this.$props.urlApiDelete + '/' + id)
            .then(function () {
                console.log('Success');
            })
            .catch(function (error) {
                console.log(error.response);
                thisObj.errors.push({ id: "image_Upload", message: error.response.data });
            });

            console.log('Refreshing file list..');
            await this.getImages();

            console.log('File delete complete.');
        }
    },
    computed: {
        errorsDistinctMessages: function () { //Return a list of distinct error messages found in the errors array, for display in the top
            var output = [];
            for (i = 0; i < this.errors.length; i++) {
                if (output[this.errors[i].message]) continue;
                output[this.errors[i].message] = true;
                output.push(this.errors[i].message);
            }
            return output;
        }
    }
    
})